// extracted by mini-css-extract-plugin
module.exports = {"container":"video-module--container--2mxof","playBtn":"video-module--playBtn--1_rbV","img":"video-module--img--31icp"};